import { IConfigsType } from '../../types'

const bibibopAccountingSalesReport: IConfigsType = {
  'bibibop-p-and-l-1-store-eaa772ee': {
    '/:brand/accounting_sales_report': {
      groupFilter: {
        api: 'locationFilter',
      },
      dateFilter: {
        types: ['year'],
        defaultType: 'year',
      },
      title: {
        type: 'title',
        title: 'Accounting Sales Report',
      },
      aiBlackbox: {
        type: 'ai-blackbox-wrapper',
        contentPartNames: ['bibibopAccountingSalesReport'],
        isLocationPage: true,
        hasDateFilter: true,
        hasGroupFilter: true,
      },
    },
  },
}

export default bibibopAccountingSalesReport
